import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppBar from "../../common/AppBar.js";
import React, { useEffect, useRef, useState } from "react";
import SearchBarWithFilter from "../../components/SearchBarWithFilter.js";
import Snackbar from "../../common/Snackbar.js";
import { useDispatch, useSelector } from "react-redux";
import { exportAuditTrailCSV, getAllAuditTrail } from "../../redux/auditTrailSlice.js";
import { formatAsTimezoneLabel } from "../../util/AppUtils.js";
import { BASE_URL } from "../../config.js";
import axios from "axios";
import AuditTrailTable from "./AuditTrailTable.js";
import {
  faArrowRight,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { showSnackbar } from "../../redux/snackbarSlice.js";
import AppTable from "../../common/AppTable/AppTable.js";
import Images from "../../assests/imgs/Imges";
import { buildPermissionContext } from "../../util/permissions";
import Loader from "../../common/Loader.js";
const AuditTrail = () => {
  const columnNames = [
    {
      headName: "User Name",
      field: "full_name",
      sort: true,
      filter: true,
      width: "160px",
    },
    { headName: "Activity", field: "action", sort: true, filter: true },
    {
      headName: "Comment",
      field: "comment",
      sort: true,
      filter: true,
      width: "200px",
    },
    {
      headName: "Date",
      field: "date",
      sort: true,
      filter: true,
      width: "160px",
    },
    { headName: "Action", field: "action_", width: "80px", textCenter: true },
  ];

  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const tableContainerRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const [showLoader, setShowLoader] = useState(false)
  const { audittrailData, pagination } = useSelector(
    (state) => state.audittrail
  );
  const authUser = useSelector((state) => state.auth.user);
  const permissionCtx = buildPermissionContext(authUser);
  const canEdit = permissionCtx.permissions?.Edit === true;
  const dispatch = useDispatch();

  const snackbar = (message, type) => {
    dispatch(showSnackbar({ type: type, message: message }));
  };

  const exportCSV = async () => {
    setShowLoader(true)
    dispatch(exportAuditTrailCSV()).then((res) => {
      setShowLoader(false)
      if (exportAuditTrailCSV.fulfilled.match(res)) {
        dispatch(showSnackbar({ type: "success", message: "Audit Trail export completed!" }));
      } else {
        dispatch(showSnackbar({ type: "error", message: "Error exporting Audit Trail CSV: " + res.payload }));
      }
    });
  };

  useEffect(() => {
    if (searchQuery.length > 0) dispatch(getAllAuditTrail({ searchQuery }));
  }, [dispatch, searchQuery]);

  const paginationLeftContent = (
    <button
      className="appbar-buttonpopup"
      style={{
        border: "1px solid #0D6EFD",
        backgroundColor: "#ffffff",
        color: "#0D6EFD",
        height: "40px",
        fontSize: "13px",
        marginLeft: "-1px",
        marginTop: "10px",
        opacity: canEdit ? 1 : 0.5,
        cursor: canEdit ? "pointer" : "not-allowed",
      }}
      onClick={exportCSV}
    >
      Export CSV
    </button>
  );
  return (
    <div>
      <AppBar
        title="Audit Trail"
        showTablesDropdown={false}
        showBlackTitle={true}
        showProfileButton={false}
        buttons={[]}
      />
      <AppTable
        ref={tableContainerRef}
        columnsData={columnNames}
        showSearchInput={true}
        paginate={true}
        pagination={{
          limit: [limit, setLimit],
          offset: [offset, setOffset],
          pagination,
          paginationPosition: {
            position: "right",
            leftContent: paginationLeftContent,
          },
        }}
        extrapadding="0px"
        onFilterSortHandler={setSearchQuery}
      >
        {audittrailData.map((d, k) => {
          return (
            <tr key={k + "ss"}>
              <td>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span>
                    <img
                      src={Images.Profile}
                      alt="user"
                      width={20}
                      style={{ borderRadius: "50%" }}
                    />
                  </span>{" "}
                  <span>
                    &nbsp;{d.first_name} {d.last_name}
                  </span>
                </div>
              </td>
              <td>{d.action}</td>
              <td>{d.comment && d.comment.length > 0 ? d.comment : "-"}</td>
              <td>{formatAsTimezoneLabel(d.audit_date)}</td>
              <td>
                <div
                  className="action-buttons"
                  style={{ marginTop: "3px", marginBottom: "3px" }}
                >
                  <button
                    className="right-arrow"
                    title="View Details"
                    onClick={() => {
                      navigate("/audit-trail/" + d.audit_trail_id);
                    }}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
      </AppTable>

      {
        showLoader && <Loader/>
      }
    </div>
  );
};

export default AuditTrail;
